/* Wicked Cozy (Kivix Main) theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var HV = window.HV || {};
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

  /* ---------------- Utilities ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || HV.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  HV.formatMoney = formatMoney;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || 'Error'); e.data = data; throw e; }
        return data;
      });
    });
  }

  /* ---------------- Marquee (motion text) ---------------- */
  function initMarquee(root) {
    $$('[data-marquee]', root).forEach(function (el) {
      if (el.classList.contains('hv-marquee--static')) return;
      var track = $('.hv-marquee__track', el);
      var group = $('.hv-marquee__group', el);
      if (!track || !group) return;
      $$('.hv-marquee__group[aria-hidden="true"]', track).forEach(function (g) { g.remove(); });
      var originals = Array.prototype.slice.call(group.children).map(function (n) { return n.cloneNode(true); });
      if (!originals.length) return;
      var guard = 0;
      while (group.scrollWidth < window.innerWidth + 200 && guard < 30) {
        originals.forEach(function (n) { group.appendChild(n.cloneNode(true)); });
        guard++;
      }
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      $$('a', clone).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(clone);
      var speed = parseFloat(el.getAttribute('data-speed')) || 40; // px per second
      var duration = Math.max(group.scrollWidth / speed, 6);
      el.style.setProperty('--marquee-duration', duration + 's');
    });
  }

  /* ---------------- Header ---------------- */
  function initHeader() {
    $$('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('aria-controls'));
        if (!nav) return;
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- Gallery ---------------- */
  function Gallery(el) {
    this.el = el;
    this.slides = $$('[data-slide]', el);
    this.thumbs = $$('[data-thumb]', el);
    this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var self = this;
    this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.go(i); }); });
    var prev = $('[data-gallery-prev]', el), next = $('[data-gallery-next]', el);
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, -1); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1, 1); });
    var main = $('.hv-gallery__main', el), startX = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) self.go(self.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        startX = null;
      });
    }
  }
  Gallery.prototype.go = function (i, dir) {
    if (!this.slides.length) return;
    var n = this.slides.length, guard = 0;
    dir = dir || 1;
    i = ((i % n) + n) % n;
    while (this.slides[i].classList.contains('is-filtered') && guard < n) { i = (((i + dir) % n) + n) % n; guard++; }
    this.slides.forEach(function (s, k) {
      s.classList.toggle('is-active', k === i);
      var v = $('video', s); if (v && k !== i) v.pause();
    });
    this.thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var activeThumb = this.thumbs[i];
    if (activeThumb && activeThumb.parentNode) {
      var p = activeThumb.parentNode;
      p.scrollTo({ left: activeThumb.offsetLeft - p.clientWidth / 2 + activeThumb.clientWidth / 2, behavior: 'smooth' });
    }
    this.index = i;
  };
  // Show only photos of one design (slides with no design always show)
  Gallery.prototype.filter = function (design, jumpToFirst) {
    function hide(el) { var d = el.getAttribute('data-design'); return !!(design && d && d !== design); }
    this.slides.forEach(function (s) { s.classList.toggle('is-filtered', hide(s)); });
    this.thumbs.forEach(function (t) { t.classList.toggle('is-filtered', hide(t)); });
    var first = this.slides.findIndex(function (s) { return !s.classList.contains('is-filtered'); });
    if (first < 0) return;
    if (jumpToFirst || this.slides[this.index].classList.contains('is-filtered')) this.go(first);
  };
  Gallery.prototype.goToMedia = function (mediaId) {
    if (!mediaId) return;
    var idx = this.slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
    if (idx > -1) this.go(idx);
  };

  /* ---------------- Product form ---------------- */
  function ProductForm(section) {
    this.section = section;
    this.form = $('form[data-product-form]', section);
    if (!this.form) return;
    var dataEl = $('[data-variants-json]', section);
    this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    this.idInput = $('input[name="id"][type="hidden"]', this.form);
    this.button = $('[data-add-to-cart]', this.form);
    this.buttonLabel = this.button ? $('[data-add-to-cart-label]', this.button) : null;
    this.error = $('[data-form-error]', this.form);
    var galleryEl = $('[data-gallery]', section);
    this.gallery = galleryEl ? new Gallery(galleryEl) : null;
    this.updateUrl = section.getAttribute('data-update-url') === 'true';
    this.sticky = $('[data-sticky-atc]', section);
    var bundleSet = $('[data-bundle-index]', this.form);
    this.bundleIdx = bundleSet ? parseInt(bundleSet.getAttribute('data-bundle-index'), 10) : -1;
    this.firstBundle = bundleSet ? bundleSet.getAttribute('data-first-bundle') : null;
    this.designIdx = section.hasAttribute('data-design-index') ? parseInt(section.getAttribute('data-design-index'), 10) : -1;
    this.filterGallery = section.getAttribute('data-filter-gallery') === 'true';

    var self = this;
    this.form.addEventListener('change', function (e) {
      if (e.target.matches('[data-tier-input]')) self.onTier(e.target);
      else if (e.target.matches('[data-design-input]')) self.onDesign();
      else if (e.target.matches('[data-option-input]')) self.onOptions();
      else if (e.target.matches('[data-addon]')) self.updateTotal();
    });
    this.form.addEventListener('submit', function (e) { self.onSubmit(e); });

    var checkedTier = $('[data-tier-input]:checked', this.form);
    if (this.bundleIdx > -1) this.onDesign(true);
    else if (checkedTier) this.onTier(checkedTier, true); else this.onOptions(true);
    this.initSticky();
  }

  ProductForm.prototype.variantById = function (id) {
    id = Number(id);
    return this.variants.find(function (v) { return v.id === id; });
  };

  /* Design + Bundle products: every bundle card follows the chosen design */
  ProductForm.prototype.selectedOptions = function () {
    var base = (this.current || this.variants[0] || { options: [] }).options.slice();
    $$('[data-design-input]:checked', this.form).forEach(function (inp) {
      base[parseInt(inp.getAttribute('data-option-index'), 10)] = inp.value;
    });
    return base;
  };
  ProductForm.prototype.findVariant = function (selected, bundleValue) {
    var bi = this.bundleIdx;
    return this.variants.find(function (v) {
      return v.options.every(function (o, i) { return i === bi ? o === bundleValue : o === selected[i]; });
    });
  };
  ProductForm.prototype.onDesign = function (initial) {
    var self = this;
    var selected = this.selectedOptions();
    var unit = this.findVariant(selected, this.firstBundle);
    $$('[data-tier-input]', this.form).forEach(function (inp) {
      var tier = inp.closest('[data-tier]');
      var v = self.findVariant(selected, inp.getAttribute('data-bundle-value'));
      tier.classList.toggle('is-unavailable', !v);
      inp.disabled = !v;
      if (!v) return;
      inp.value = v.id;
      var qty = parseInt(inp.getAttribute('data-qty'), 10) || 1;
      var ref = unit ? unit.price * qty : 0;
      if (v.compare_at_price > ref) ref = v.compare_at_price;
      var saving = ref - v.price;
      inp.setAttribute('data-reference', saving > 0 ? ref : '');
      var priceEl = $('[data-tier-price]', tier); if (priceEl) priceEl.textContent = formatMoney(v.price);
      var refEl = $('[data-tier-ref]', tier);
      if (refEl) { refEl.textContent = saving > 0 ? formatMoney(ref) : ''; refEl.hidden = !(saving > 0); }
      var saveEl = $('[data-tier-save]', tier);
      if (saveEl) {
        saveEl.hidden = !(saving > 0);
        if (saving > 0) saveEl.textContent = (saveEl.getAttribute('data-template') || 'Save [amount]').replace('[amount]', formatMoney(saving)).replace('[percent]', Math.round(saving / ref * 100) + '%');
      }
      var eachEl = $('[data-tier-each]', tier);
      if (eachEl) eachEl.textContent = (eachEl.getAttribute('data-template') || '[amount] each').replace('[amount]', formatMoney(Math.round(v.price / qty)));
      var soldEl = $('[data-tier-soldout]', tier); if (soldEl) soldEl.hidden = !!v.available;
      if (v.thumb) $$('[data-tier-thumb]', tier).forEach(function (img) { img.src = v.thumb; });
    });
    $$('[data-design-group]', this.form).forEach(function (g) {
      var c = $('[data-design-input]:checked', g), l = $('[data-design-label]', g);
      if (c && l) l.textContent = c.value;
    });
    var checked = $('[data-tier-input]:checked', this.form);
    if (!checked || checked.disabled) {
      checked = $$('[data-tier-input]', this.form).filter(function (i) { return !i.disabled; })[0];
      if (checked) checked.checked = true;
    }
    if (this.gallery && this.filterGallery && this.designIdx > -1) this.gallery.filter(selected[this.designIdx], !initial);
    if (checked) this.onTier(checked, initial);
  };

  ProductForm.prototype.onTier = function (input, initial) {
    var v = this.variantById(input.value);
    this.current = v;
    this.currentTier = input;
    this.render(v, initial);
  };

  ProductForm.prototype.onOptions = function (initial) {
    var groups = $$('[data-option-group]', this.form);
    if (!groups.length) {
      this.current = this.variantById(this.idInput ? this.idInput.value : null) || this.variants[0];
      this.render(this.current, initial);
      return;
    }
    var selected = groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
    var v = this.variants.find(function (variant) {
      return variant.options.every(function (o, i) { return o === selected[i]; });
    });
    this.current = v;
    this.currentTier = null;
    this.render(v, initial);
  };

  ProductForm.prototype.render = function (v, initial) {
    var s = HV.strings || {};
    if (this.idInput && v) this.idInput.value = v.id;
    var unit = this.currentTier ? this.currentTier.dataset : null;

    // Price block
    var price = v ? v.price : 0;
    var compare = 0;
    if (unit && unit.reference) compare = parseInt(unit.reference, 10) || 0;
    else if (v && v.compare_at_price) compare = v.compare_at_price;
    if (compare <= price) compare = 0;

    $$('[data-price-current]', this.section).forEach(function (el) { el.textContent = formatMoney(price); });
    $$('[data-price-compare]', this.section).forEach(function (el) {
      el.textContent = compare ? formatMoney(compare) : '';
      el.hidden = !compare;
    });
    $$('[data-price-save]', this.section).forEach(function (el) {
      if (!compare) { el.hidden = true; return; }
      var tpl = el.getAttribute('data-template') || 'You save [amount]';
      var pct = Math.round(((compare - price) / compare) * 100);
      el.textContent = tpl.replace('[amount]', formatMoney(compare - price)).replace('[percent]', pct + '%');
      el.hidden = false;
    });
    $$('[data-price-each]', this.section).forEach(function (el) {
      var qty = unit ? parseInt(unit.qty, 10) || 1 : 1;
      if (qty > 1) {
        el.textContent = (el.getAttribute('data-template') || '[amount] per robe').replace('[amount]', formatMoney(Math.round(price / qty)));
        el.hidden = false;
      } else el.hidden = true;
    });
    var badge = $('[data-gallery-save]', this.section);
    if (badge) {
      if (compare) { badge.textContent = (badge.getAttribute('data-template') || 'Save [percent]').replace('[percent]', Math.round(((compare - price) / compare) * 100) + '%'); badge.hidden = false; }
      else badge.hidden = true;
    }

    // Stock
    $$('[data-stock]', this.section).forEach(function (el) {
      var label = $('[data-stock-label]', el);
      var low = parseInt(el.getAttribute('data-low'), 10) || 0;
      el.classList.remove('hv-stock--low', 'hv-stock--out');
      if (!v || !v.available) { el.classList.add('hv-stock--out'); label.innerHTML = el.getAttribute('data-out'); return; }
      if (v.inventory_management && v.inventory_policy === 'deny' && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
        el.classList.add('hv-stock--low');
        label.innerHTML = (el.getAttribute('data-lowtext') || '').replace('[count]', v.inventory_quantity);
        return;
      }
      label.innerHTML = el.getAttribute('data-in');
    });

    // Button
    if (this.button) {
      var text = !v ? s.unavailable : (v.available ? (this.button.getAttribute('data-label') || s.addToCart) : s.soldOut);
      this.button.disabled = !v || !v.available;
      if (this.buttonLabel) this.buttonLabel.textContent = text;
    }
    if (this.sticky) {
      var sb = $('[data-sticky-button]', this.sticky);
      var sp = $('[data-sticky-price]', this.sticky);
      var sv = $('[data-sticky-variant]', this.sticky);
      if (sb) { sb.disabled = !v || !v.available; }
      if (sp) sp.textContent = formatMoney(price);
      if (sv) sv.textContent = v && v.title !== 'Default Title' ? v.title : '';
      var si = $('.hv-sticky__img', this.sticky);
      if (si && v && v.thumb) { si.removeAttribute('srcset'); si.src = v.thumb; }
    }

    this.updateTotal();

    if (!initial && v) {
      if (this.gallery && v.media_id) this.gallery.goToMedia(v.media_id);
      if (this.updateUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    this.hideError();
  };

  ProductForm.prototype.updateTotal = function () {
    var total = this.current ? this.current.price : 0;
    $$('[data-addon]:checked', this.form).forEach(function (a) { total += parseInt(a.getAttribute('data-price'), 10) || 0; });
    $$('[data-total]', this.section).forEach(function (el) { el.textContent = formatMoney(total); });
  };

  ProductForm.prototype.showError = function (msg) {
    if (!this.error) return alert(msg);
    this.error.textContent = msg; this.error.classList.add('is-visible');
  };
  ProductForm.prototype.hideError = function () { if (this.error) this.error.classList.remove('is-visible'); };

  ProductForm.prototype.onSubmit = function (e) {
    if (!this.current) { e.preventDefault(); return; }
    e.preventDefault();
    var self = this;
    var items = [{ id: this.current.id, quantity: 1 }];
    $$('[data-addon]:checked', this.form).forEach(function (a) {
      var id = parseInt(a.getAttribute('data-variant-id'), 10);
      if (id) items.push({ id: id, quantity: 1 });
    });
    var props = {};
    $$('[name^="properties["]', this.form).forEach(function (inp) {
      var key = inp.name.replace(/^properties\[/, '').replace(/\]$/, '');
      if (inp.value) props[key] = inp.value;
    });
    if (Object.keys(props).length) items[0].properties = props;

    var btns = [this.button].concat(this.sticky ? [$('[data-sticky-button]', this.sticky)] : []).filter(Boolean);
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    if (this.buttonLabel) this.buttonLabel.textContent = (HV.strings || {}).adding || '…';

    fetchJSON(HV.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(function () {
        if (HV.cartType === 'checkout') { window.location.href = '/checkout'; return; }
        if (HV.cartType === 'page') { window.location.href = HV.routes.cart; return; }
        return CartDrawer.open();
      })
      .catch(function (err) { self.showError(err.message || (HV.strings || {}).cartError); })
      .finally(function () {
        btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
        self.render(self.current, true);
      });
  };

  ProductForm.prototype.initSticky = function () {
    var sticky = this.sticky, btn = this.button, self = this;
    if (!sticky || !btn) return;
    var sb = $('[data-sticky-button]', sticky);
    if (sb) sb.addEventListener('click', function () {
      if (self.form.requestSubmit) self.form.requestSubmit(btn); else btn.click();
    });
    if (!('IntersectionObserver' in window)) return;
    var footer = $('.site-footer');
    var buyVisible = true, footerVisible = false;
    function update() { sticky.classList.toggle('is-visible', !buyVisible && !footerVisible); sticky.setAttribute('aria-hidden', buyVisible || footerVisible ? 'true' : 'false'); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { buyVisible = en.isIntersecting || en.boundingClientRect.top > 0; });
      update();
    }).observe(btn);
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
  };

  /* ---------------- Cart drawer ---------------- */
  var CartDrawer = {
    el: null,
    init: function () {
      this.el = document.getElementById('CartDrawer');
      var self = this;
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && self.el && HV.cartType === 'drawer') { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      if (!this.el) return;
      this.el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-change]');
        if (btn) { self.change(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10)); }
      });
      this.el.addEventListener('change', function (e) {
        if (e.target.matches('[data-qty-input]')) self.change(e.target.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
      });
    },
    open: function () {
      var self = this;
      return this.refresh().then(function () {
        if (!self.el) { window.location.href = HV.routes.cart; return; }
        self.lastFocus = document.activeElement;
        self.el.classList.add('is-open');
        self.el.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var c = $('[data-cart-close]', self.el); if (c) c.focus();
      });
    },
    close: function () {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    },
    change: function (key, qty) {
      var self = this;
      fetchJSON(HV.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (cart) { self.render(cart); })
        .catch(function (err) { alert(err.message); self.refresh(); });
    },
    refresh: function () {
      var self = this;
      return fetchJSON(HV.routes.cart + '.js').then(function (cart) { self.render(cart); return cart; });
    },
    render: function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
      if (!this.el) return;
      var s = HV.strings || {};
      var list = $('[data-cart-items]', this.el);
      var foot = $('[data-cart-foot]', this.el);
      if (!cart.item_count) {
        list.innerHTML = '<div class="cart-drawer__empty"><p>' + escapeHtml(s.cartEmpty) + '</p><a class="btn btn--small" href="' + HV.routes.root + '" data-cart-close>Continue shopping</a></div>';
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      list.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
        var discounts = (item.line_level_discount_allocations || []).map(function (d) {
          return '<div class="cart-line__discount">' + escapeHtml(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</div>';
        }).join('');
        var orig = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
        return '<div class="cart-line">' +
          (img ? '<img class="cart-line__img" src="' + img + '" alt="" loading="lazy" width="72" height="72">' : '<div class="cart-line__img"></div>') +
          '<div><a class="cart-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant + discounts +
          '<div><div class="qty"><button type="button" data-qty-change data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="−">−</button>' +
          '<input type="number" min="0" value="' + item.quantity + '" data-qty-input data-key="' + item.key + '" aria-label="Quantity">' +
          '<button type="button" data-qty-change data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="+">+</button></div>' +
          '<button type="button" class="cart-line__remove" data-qty-change data-key="' + item.key + '" data-qty="0">' + escapeHtml(s.remove) + '</button></div></div>' +
          '<div class="cart-line__price">' + orig + formatMoney(item.final_line_price) + '</div></div>';
      }).join('');
      var savings = cart.original_total_price - cart.total_price;
      var saveRow = $('[data-cart-savings-row]', this.el);
      if (saveRow) { saveRow.hidden = savings <= 0; $('[data-cart-savings]', saveRow).textContent = '−' + formatMoney(savings); }
      var sub = $('[data-cart-subtotal]', this.el); if (sub) sub.textContent = formatMoney(cart.original_total_price);
      var tot = $('[data-cart-total]', this.el); if (tot) tot.textContent = formatMoney(cart.total_price);
    }
  };
  HV.CartDrawer = CartDrawer;

  /* ---------------- Spoiler blur ---------------- */
  function initSpoilers(root) {
    $$('[data-spoiler-toggle]', root).forEach(function (btn) {
      if (btn._hv) return; btn._hv = true;
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (!target) return;
        var on = target.classList.toggle('is-spoiler');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var lbl = $('[data-spoiler-label]', btn);
        if (lbl) lbl.textContent = on ? btn.getAttribute('data-show') : btn.getAttribute('data-hide');
      });
    });
  }

  /* ---------------- Countdown ---------------- */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el._hvTimer) clearInterval(el._hvTimer);
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) return;
      var d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
      var done = $('[data-countdown-done]', el), units = $('.hv-countdown__units', el);
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = Math.max(0, target - Date.now());
        d.textContent = pad(Math.floor(diff / 864e5));
        h.textContent = pad(Math.floor(diff / 36e5) % 24);
        m.textContent = pad(Math.floor(diff / 6e4) % 60);
        s.textContent = pad(Math.floor(diff / 1e3) % 60);
        if (diff === 0) { clearInterval(el._hvTimer); if (done) { done.hidden = false; if (units) units.hidden = true; } }
      }
      tick();
      el._hvTimer = setInterval(tick, 1000);
    });
  }

  /* ---------------- Reveal ---------------- */
  function initReveal(root) {
    var els = $$('.reveal', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- Boot ---------------- */
  function initSection(root) {
    initMarquee(root);
    initSpoilers(root);
    initCountdowns(root);
    initReveal(root);
    $$('[data-product-section]', root).forEach(function (s) { new ProductForm(s); });
    $$('[data-gallery]:not([data-gallery-bound])', root).forEach(function (g) {
      if (g.closest('[data-product-section]')) return;
      g.setAttribute('data-gallery-bound', ''); new Gallery(g);
    });
  }

  /* Links/buttons with data-select-design="Name" switch the buy box to that design */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-select-design]');
    if (!link) return;
    var want = (link.getAttribute('data-select-design') || '').trim().toLowerCase();
    var input = $$('[data-design-input]').filter(function (i) { return i.value.trim().toLowerCase() === want; })[0];
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    CartDrawer.init();
    initSection(document);
    var resizeT;
    window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(function () { initMarquee(document); }, 250); });
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
})();
